import React, { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Logo from '../../assets/images/logo_B.svg';
import Phone from '../../assets/images/phone_call.svg';
import Menu from '../../assets/images/menu.svg';
import Close from '../../assets/images/close.svg';

import ToggleModal from '../../helpers/ToggleModal';

import ButtonLink from "../../components/Button/index";
import ModalMenu from "../../components/ModalMenu/index";

import './index.scss';

function Header() {
  const { lang } = useParams(); // Получаем текущий язык из URL
  const { t, i18n } = useTranslation(); 
  const navigate = useNavigate();

  const changeLanguage = (lang) => {
    lang = lang.toLowerCase()
    i18n.changeLanguage(lang);
    document.documentElement.setAttribute("lang", lang); 

    const currentPath = window.location.pathname.split('/').slice(2).join('/'); 
    navigate(`/${lang}/${currentPath}`);

    localStorage.setItem("i18nextLng", lang); 
  };


  const changeLangLabel = (label) => {
    label = label.toLowerCase();
    if(label === "ua"){
      return "en";
    }else if(label === "en"){
      return "nl";
    }else if(label === "nl"){
      return "ua";
    }
  }
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      document.documentElement.setAttribute("lang", savedLanguage);
    }
  }, [i18n]);

  return (
      <div className="header">
        <div className="part part-left">
          <button onClick={ToggleModal} className='btn btn-burger' id="burger" aria-label="Burger Button"></button>
          <div id="phoneNum">
            <div className='phone number' >072 5203013</div>
            <div className='phone image'><a href={`tel:+31725203013`} aria-label="Phone number"><img src={Phone} alt=''/></a></div>
          </div>
          <div className='btn-lang mobile'>
            <select
            onChange={(e) => changeLanguage(e.target.value)}
            defaultValue={i18n.language}
            className="language-select"
            aria-label="Language Select"
            >
              <option value="ua">UA</option>
              <option value="en">EN</option>
              <option value="nl">NL</option>
            </select>
          </div>
        </div>
          <ButtonLink to={`/${lang}/`} className='logo'>
            <img src={Logo} alt=""/>
          </ButtonLink>
        <div className="part part-right">
          <div className='btn-lang desktop'>
            <select
            onChange={(e) => changeLanguage(e.target.value)}
            defaultValue={i18n.language}
            className="language-select"
            >
              <option value="ua">UA</option>
              <option value="en">EN</option>
              <option value="nl">NL</option>
            </select>
          </div>
          <div className='btn-lang'>
          <ButtonLink to={`/${lang}/reservation`} className='lineOff reservation'>
            {t('reservation')}
          </ButtonLink>
          </div>
        </div>
        <ModalMenu/>
      </div>
    )
}


export default Header;
  